<template>
  <div :style="wrapStyle" @click="handleClickEvent">
    <c-button ref="button" :style="{...bgImageStyle}" v-bind="$props"></c-button>
    <c-base-dialog
      v-model="showInvitedDialog"
      :option="invitedOption"
      @close="closeShowInvitedDialog"
      @confirm="helpOrInvitedFunc"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('dialog-content')">
          <img
                :class="getCss('avatar')"
                v-if="inviteInfo.avatar"
               :src="inviteInfo.avatar" alt="">
          <p  :class="getCss('invite-user-name')"
              v-html="`你的好友:&nbsp;${inviteInfo.inviter_name}`"></p>
          <p
            :class="getCss('invite_name')"
            v-html="inviteJoinTips"
          />
          <div :class="getCss('help_gift_img_area')">
            <img v-if="!!helpGiftImage" :class="getCss('help_gift_img')" :src="helpGiftImage" alt />
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin, baseComponents } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CTgclubUserInviteShare',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'Tgclub-user-invite-',
      // 客态 被邀请的码
      inviteCode: '',
      //  主态 邀请码
      selfInviteCode: '',
      distributedData: '',
      showInvitedDialog: false,
      inviteInfo: {
        inviter_name: '',
        avatar: '',
      },
    };
  },
  computed: {
    invitedOption() {
      const { dialogStyle = {} } = this.dialogConfig;
      const extend = {
        fotter: true,
        confirm: this.helpButtonIcon ? true : '帮TA助力',
        header: this.configurationData.helpPopTitle || '邀请助力',
        dialogStyle: this.helpDialogBgImage
          ? {
            ...dialogStyle,
            backgroundImage: `url('${this.helpDialogBgImage}')`,
            ...this.inviteMsgContentStyle,
          }
          : { ...dialogStyle, ...this.inviteMsgContentStyle },
        confirmStyle: Object.assign(
          {},
          this.helpButtonIcon
            ? {
              width: '2.2rem',
              background: `url('${this.helpButtonIcon}')`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }
            : {
              width: '2.2rem',
              background: this.dialogConfig?.dialogStyle?.color,
            },
        ),
        cancel: false,
        closeLocation: 'bottom-center',
        close: true,
        height: '7rem',
        titleStyle: this.inviteHelpPopTitleStyle,
      };
      extend.dialogStyle.height = '7rem';
      return Object.assign({}, this.dialogConfig, extend);
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    // 邀请标题的样式
    inviteHelpPopTitleStyle() {
      return this.styles?.inviteHelpPopTitleStyle ?? {};
    },
    // 邀请文案的样式
    inviteMsgContentStyle() {
      const style =  this.styles?.inviteMsgContentStyle ?? {};
      if (!style.color) style.color = this.configurationData.invitedTextColor || '#ffffff';
      return  style;
    },
    // 按钮背景图
    bgImageStyle() {
      return {
        backgroundImage: `url(${this.configurationData.bgImage || ''})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
      };
    },
    // 前置条件判断
    preConditionFlowId() {
      return this.configurationData.preConditionFlowId || 0;
    },
    // 检测助力弹框是否弹出
    checkHelpConditionFlowId() {
      return this.configurationData.checkHelpConditionFlowId || 0;
    },
    // 是否需要邀请码
    isInvite() {
      return this.configurationData.isInvite || false;
    },
    // 邀请回调 心悦邀请回调
    callBackFlowId() {
      return this.configurationData.callBackFlowId || 0;
    },
    // begin ###应邀模式####
    isHasInvitedAccess() {
      return this.configurationData.invitedModeConfig.isHasInvitedAccess || 0;
    },
    // 助力或标记流程
    invitedFlowId() {
      return this.configurationData.invitedModeConfig.invitedFlowId || 0;
    },
    helpGiftImage() {
      return this.configurationData.invitedModeConfig.helpGiftImage || '';
    },
    // 助力icon
    helpButtonIcon() {
      return this.configurationData.invitedModeConfig.helpButtonIcon || '';
    },
    helpDialogBgImage() {
      return this.configurationData.invitedModeConfig.helpDialogBgImage || '';
    },
    successHelpTip() {
      return this.configurationData.invitedModeConfig.successHelpTip || '助力成功!';
    },
    inviteJoinTips() {
      return this.configurationData.invitedModeConfig.inviteJoinTips || '邀请帮助TA领取专属福利';
    },
    isIOS() {
      return this.$platform.isIos;
    },
    // end ###应邀模式####
  },
  async mounted() {
    console.log(' version 1.0.0 tgclub-user-invite configurationData=', this.configurationData);
    const { isAcceptDistributedData  = false } = this.configurationData;
    if (isAcceptDistributedData === true) {
      this.$eventBus.$on('ceiba:common:events:distributed-data', ({ link }) => {
        if (link) {
          this.distributedData = link;
          console.log('this.distributedData in share components link ', this.distributedData);
          this.doShareSetting(link, false);
        }
      });
    }
    await this.initialize();
  },
  methods: {
    // 判断邀
    async handleInvitePreCondition() {
      if (this.preConditionFlowId <= 0) {
        return true;
      }
      const response = await this.flowRequest({
        flowId: this.preConditionFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('邀请或助力 pre condition check =', response);
      const { ret, msg, data = {} } = response;
      const { ret: rspRet, msg: rspMsg } = data;

      if (ret !== 0 || rspRet !== 0) {
        this.$alert({ msg: msg || rspMsg || '不满足邀请条件' });
        return false;
      }
      return true;
    },
    // 关闭应邀模式
    closeShowInvitedDialog() {
      this.showInvitedDialog = false;
    },
    // 获取助力客态的
    //  助力或应邀模式
    helpOrInvitedFunc() {
      if (this.isHasInvitedAccess <= 0) {
        return false;
      }

      console.log('invitedFlowId', this.invitedFlowId);
      if (this.invitedFlowId <= 0) {
        this.closeShowInvitedDialog();
        return false;
      }

      const { helpOrInvitedForceRole = false } = this.configurationData;
      console.log('helpOrInvitedForceRole is forceRole', helpOrInvitedForceRole);
      //   绑定角色
      if (helpOrInvitedForceRole === true && !this.isRoleReady) {
        const self = this;
        try {
          this.closeShowInvitedDialog();
          this.$onRoleReady(async () => {
            if (this.isRoleReady && !this.accessHelpOrInvitedAfterBind) {
              this.accessHelpOrInvitedAfterBind = true;
              this.helpOrInvitedFunc();
            }
          });
          baseComponents.gameRoleSelect.showGameRoleSelect(this.actInfo.game_code, {}).then((roleInfo) => {
            console.log('store select role=', roleInfo);
            self.$store.dispatch('saveCurrentRole', {
              isRoleReady: true,
              roleInfo,
            });
          });
          // 绑定助力需要角色
        } catch (e) {
          console.error('showGameRoleSelect fail| err=', e);
        }
        return;
      }
      const inviteCode = common.tool.getQueryparams('c_invite_code') || '';
      // 助力
      this.flowRequest({
        flowId: this.invitedFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            invite_code: inviteCode,
            name: this.userInfo.nickName ?  encodeURIComponent(this.userInfo.nickName) : '',
            avatar: this.userInfo.avatar,
          }),
        },
      }).then((response) => {
        console.log(' helpOrInvitedFunc callback response', response);
        const { ret, msg, data = {} } = response;
        if (ret !== 0) {
          this.$alert({ msg });
          this.reportFunc('assist', { status: '0' });

          return false;
        }
        const { ret: resRet, msg: resMsg } = data;
        if (resRet !== 0) {
          this.$alert({ msg: resMsg });
          this.reportFunc('assist', { status: '0' });

          return false;
        }
        if (ret === 0) {
          this.refreshQua(); // 刷新资格
          this.closeShowInvitedDialog();
          this.$alert({ msg: this.successHelpTip });
          this.reportFunc('assist', { status: '1' });
          this.helpOrInvitedAccessActionCallBack();
        }
      });
    },
    // 助力后触发动作
    helpOrInvitedAccessActionCallBack() {
      const { targetComponentId = '', isRelationComponent = false } = this.configurationData;
      if (!targetComponentId || isRelationComponent === false) return false;
      const parentRef = (node) => {
        if (!node?.$parent) {
          return {};
        }
        // eslint-disable-next-line  no-underscore-dangle
        if (node.$parent && node.$parent?.$el?._prevClass === 'page-content') {
          return node.$parent;
        }
        return parentRef(node.$parent);
      };
      const parentNode = parentRef(this.$refs.button);
      if (!parentNode) {
        console.error('--parentNode-- not found ', parentNode);
      }
      const component = parentNode?.$refs[targetComponentId]?.[0];
      // 调用其他组件的事件
      if (component && typeof component.doTaskAction === 'function') {
        component.doTaskAction();
        return false;
      }
      // 调用c-button的事件
      if (component && typeof component.handleClick === 'function') {
        component.handleClick();
        return false;
      }
      console.error('helpOrInvitedAccessActionCallBack not found doTaskAction or handleClick function ', component);
    },

    async initialize() {
      console.log('this.configurationData in Tgclub-user-invite = 1.0.0 ', this.configurationData);
      if (this.$isInEditor) return;
      this.$refs.button.setClickHandler(this.invite, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.configurationData.forceRole,
      });
      this.$onLogined(async () => {
        await this.HandleInviteCode();
        this.closeShare();
      });
    },
    closeShare() {
      /**
       *关闭心悦app 右上角的分享按钮
       */
      if (this.configurationData.closeShareBtn && window.Tgclub) {
        console.log('this.configurationData in hideFunctionButton navigator.userAgent', navigator.userAgent);
        if (navigator.userAgent.toLowerCase().indexOf('tgclub') !== -1) {
          // 隐藏分享按钮
          console.log('this.configurationData in hideFunctionButton ios', this.isIOS);
          if (this.isIOS) {
            // ios
            console.log('this.configurationData in hideFunctionButton ios');
            window.document.addEventListener(
              'TgclubReady',
              () => {
                console.log('this.configurationData in hideFunctionButton ');
                window.Tgclub.hideFunctionButton();
              },
              false,
            );
            window.Tgclub.hideFunctionButton();
            console.log('is success');
          } else {
            // if ('undefined' != typeof (window.Tgclub)) { // 安卓
            console.log('this.configurationData in hideFunctionButton');
            // console.log('this.configurationData in hideFunctionButton', Tgclub);
            // console.log('this.configurationData in hideFunctionButton', Tgclub.hideFunctionButton);
            window.Tgclub.hideFunctionButton();
            console.log('is success');
            // }
          }
        }
      }
      /**
       *关闭心悦app 右上角的分享按钮
       */
    },
    // 判断应邀模式
    async HandleInviteCode() {
      if (this.$ast.isAPP()) {
        return false;
      }

      if (!this.isHasInvitedAccess) {
        return false;
      }
      const inviteCode = common.tool.getQueryparams('c_invite_code') || '';
      this.inviteCode = inviteCode;
      if (!inviteCode) {
        return false;
      }
      const params = {
        business: this.$actInfo.ast,
        activity: `${this.$actInfo.activity_id}`,
        invite_code: inviteCode,
      };
      const response = await baseComponents.Apis.User.getInviteInfo(params);
      console.log('response GetInviteInfo ', response);
      const { ret, data = {}, msg } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '获取邀请码失败' });
        this.reportFunc('assist', { status: '0' });
        return;
      }
      const { self = false } = data;
      if (self === true) {
        console.error('invite check fail  for self check  invite info');
        return;
      }
      // 查询两者是否已经建立了邀请
      if (this.checkHelpConditionFlowId > 0) {
        const checkResponse = await this.flowRequest({
          flowId: this.checkHelpConditionFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.error('checkResponse help invite related ', checkResponse);
        const { ret, data = {} } = checkResponse;
        const { ret: resRet, related = 0 } = data;
        if (ret !== 0) {
          // this.reportFunc('assist', { status: '0' });
          return;
        }
        if (resRet !== 0) {
          // this.reportFunc('assist', { status: '0' });
          return;
        }
        if (related > 0) {
          // this.reportFunc('assist', { status: '0' });
          return;
        }
      }

      const { ext = '{}' } = data;
      const extMsg = JSON.parse(ext);
      this.inviteInfo.inviter_name = extMsg.name || '';
      this.inviteInfo.avatar = extMsg.avatar || '';
      this.showInvitedDialog = true;
      return response;
    },
    // 判断
    async handleInviteClick() {
      // # 需要邀请码
      const params = {
        business: this.$actInfo.ast,
        activity: `${this.$actInfo.activity_id}`,
        ext: JSON.stringify({
          name: this.userInfo.nickName,
          avatar: this.userInfo.avatar || 'https://game.gtimg.cn/images/js/img/lottery/default_head.png',
          dynamicPageId: this.userInfo.dynamicPageId,
        }),
      };
      console.log('getInviteCode', this.userInfo, params);
      const response = await baseComponents.Apis.User.getInviteCode(params);
      console.log('getInviteCode response = ', response);
      const { ret, data = {} } = response || {};
      const { invite_code: inviteCode = '' } = data;
      if (ret !== 0 || !inviteCode) {
        this.toast('获取邀请码失败');
        this.selfInviteCode = '';
        return false;
      }
      this.selfInviteCode = inviteCode;
      return this.selfInviteCode;
    },
    async invite() {
      const invitePreCheckRes = await this.handleInvitePreCondition();
      if (!invitePreCheckRes) {
        return false;
      }
      if (this.isInvite) {
        await this.handleInviteClick();
      }
      console.log('this.distributedData =', this.distributedData);
      let link = common.tool.setUrlParam(
        'c_invite_code',
        this.selfInviteCode,
        this.distributedData || this.configurationData.link || this.shareConfig.link || window.location.href,
      );

      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source']);

      link = common.tool.setUrlParam('t', `${new Date().getTime()}`, link);
      this.doShareSetting(link, true);
    },
    doShareSetting(link, viaClick) {
      console.log('doShareSetting link = ', link);
      const that = this;
      Object.defineProperty(window, 'hasTgclubShareAction', {
        set: (newValue) => {
          if (newValue > 0) {
            console.log('分享成功~~~~~~~~~~~~~~~~~~~~~~~');
            that.callBack();
          }
        },
        enumerable: true,
        configurable: true,
      });
      let callback = function (ret) {
        console.log('ios 分享 ret =', ret);
        window.hasTgclubShareAction = 0;
        if (ret.result === '1') {
          window.hasTgclubShareAction = 1;
          console.log('ios 分享~suc');
        } else {
          console.log('ios分享~~失败');
        }
      };
      if (common.platform.isAndroid && this.$ast.isAPP()) {
        // 心悦app 安卓分享回调是一个字符串
        callback = `function(ret) { var jsonArr = JSON.parse(ret);window.hasTgclubShareAction = 0;
            if(jsonArr.onCheckResult == 1){window.hasTgclubShareAction = 1;console.log("分享~suc");}
            else{console.log("分享~~~失败");}}`;
      }
      const shareNewConfig = {
        title: this.configurationData.title || this.shareConfig.title,
        link,
        desc: this.configurationData.desc || this.shareConfig.desc, // 分享标题，默认为活动页面标题（可手动调整）, //分享活动简介
        icon: this.configurationData.icon || this.shareConfig.icon, // 分享后朋友看到的图标
        callback,
      };
      // const that = this;
      // const getLateTime = this.configurationData.lateTime || 500
      // setTimeout(() => {
      //   console.log('执行回调callBack流程');
      //   that.callBack();
      // }, 2000);
      console.log('share new config =', shareNewConfig);
      this.reportFunc('share', {});
      if (this.configurationData.forceApp || this.$ast.isAPP()) {
        this.$ast.setAPPShare(shareNewConfig);
        if (viaClick) {
          this.$ast.goAPPShare();
        }
      } else {
        if (viaClick) {
          this.doShare(shareNewConfig);
        }
      }
    },
    reportFunc(key, eventData) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log(`reportFunc ${key}  report data =`, params);
      }
    },
    doTaskAction(taskIdRemarkKey) {
      if (taskIdRemarkKey) {
        // eslint-disable-next-line no-underscore-dangle
        this.__taskIdRemarkKey__ = taskIdRemarkKey;
        this.invite();
      }
    },
    finishTaskAction(value) {
      // eslint-disable-next-line no-underscore-dangle
      if (this.__taskIdRemarkKey__) {
        // eslint-disable-next-line no-underscore-dangle
        window[this.__taskIdRemarkKey__] = value;
      }
    },
    // 分享回调
    async callBack() {
      console.log('run  doShare callback and this.callBackFlowId = ', this.callBackFlowId);
      this.finishTaskAction(1);
      if (this.callBackFlowId > 0) {
        const { callBackNeedRole = false } =  this.configurationData;
        const params = {};
        if (callBackNeedRole === true) {
          params.role = this.roleInfo;
        }
        console.log('run  doShare callback and params', params);
        const response = await this.flowRequest({
          flowId: this.callBackFlowId,
          params,
        });
        this.refreshQua(); // 刷新礼包
        console.log('share callback ', this.callBackFlowId, response);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
